export const TMS_MODULE_CODES = ["tms"];

function menuSortValue(item: any): number {
    const raw = item?.priority ?? item?.displayOrder ?? item?.sortOrder ?? item?.sequence;
    const n = Number(raw);
    return Number.isFinite(n) ? n : 0;
}

export function isTmsModule(menuItem: { code?: string; moduleName?: string; moduleCode?: string } | null | undefined): boolean {
    if (!menuItem) return false;
    const code = (menuItem.code || menuItem.moduleCode || "").toLowerCase();
    const name = (menuItem.moduleName || "").toLowerCase();
    return TMS_MODULE_CODES.includes(code) || name === "tms";
}

export function getTopLevelMenus(modulePermission: any[] | undefined): any[] {
    return sortTopNavMenus(
        (modulePermission || []).filter((f: any) => !f.parentCode || f.parentCode === "")
    );
}

/** Orders header tabs by backend priority (1 before 2). */
export function sortTopNavMenus(menus: any[]): any[] {
    return [...(menus || [])].sort((a, b) => {
        const byPriority = menuSortValue(a) - menuSortValue(b);
        if (byPriority !== 0) return byPriority;
        const aName = (a.moduleName || a.code || "").toLowerCase();
        const bName = (b.moduleName || b.code || "").toLowerCase();
        return aName.localeCompare(bName);
    });
}

export function normalizeMenuPath(url?: string): string {
    if (!url) return "";
    const path = url.split("?")[0];
    return path.endsWith("/") && path.length > 1 ? path.slice(0, -1) : path;
}

export function pathMatchesMenu(pathname: string, menuUrl?: string, search = ""): boolean {
    if (!menuUrl) return false;

    const [rawMenuPath, menuQuery] = menuUrl.split("?");
    const menuPath = normalizeMenuPath(rawMenuPath);
    if (!menuPath) return false;

    const currentPath = normalizeMenuPath(pathname);
    const pathOk = menuQuery
        ? currentPath === menuPath
        : currentPath === menuPath || currentPath.startsWith(`${menuPath}/`);
    if (!pathOk) return false;

    if (!menuQuery) return true;

    const menuParams = new URLSearchParams(menuQuery);
    const currentSearch = search.startsWith("?") ? search.slice(1) : search;
    const currentParams = new URLSearchParams(currentSearch);

    return Array.from(menuParams.keys()).every((key) => currentParams.get(key) === menuParams.get(key));
}

export function menuItemIsActive(pathname: string, item: any, search = ""): boolean {
    if (pathMatchesMenu(pathname, item?.url, search)) return true;
    return item?.children?.some((child: any) => menuItemIsActive(pathname, child, search)) ?? false;
}

const MENU_LABEL_OVERRIDES: Record<string, string> = {
    enquirynow: "Enquiry Now",
    externalguest: "External Guest",
    generalmaster: "General Master",
    companyprofile: "Company Profile",
    hradmin: "HR / Admin",
    enquirylist: "Enquiry List",
    addenquiry: "Add Enquiry",
    cancelenquirylist: "Cancel Enquiry List",
    bookinglist: "Booking List",
    addbooking: "Add Booking",
    campaignlist: "Campaign List",
    campaignbuilder: "Campaign Builder",
    contactlist: "Contact List",
    contactgroup: "Contact Group",
    addnewcontact: "Add New Contact",
    generatequotation: "Generate Quotation",
};

function labelKey(value?: string): string {
    return (value || "").toLowerCase().replace(/[\s/_-]+/g, "");
}

/** Human-readable label for sidebar / flyout menu items (handles API camelCase names). */
export function formatMenuLabel(name?: string, code?: string): string {
    const key = labelKey(code) || labelKey(name);
    if (key && MENU_LABEL_OVERRIDES[key]) return MENU_LABEL_OVERRIDES[key];

    if (!name) return "";
    if (/\s/.test(name)) return name;

    return name
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2")
        .trim();
}
